export { TrainComponent } from './train.component';
